import { deepFreeze } from 'utils/deepFreeze';
import { ForYouState } from '../types';

export const initialState: Readonly<ForYouState> = deepFreeze({});
